export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}/stock-take/create`,
        name: `${prefix}.stock-take.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-take.create`,
                PageDescription: "Inventory management: stock take",
            },
        },
    },
    {
        path: `/${prefix}/stock-take`,
        name: `${prefix}.stock-take.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-take.create`,
                PageDescription: "Inventory management: stock take",
            },
        },
    }, {
        path: `/${prefix}/stock-take-list`,
        name: `${prefix}.stock-take-list.index`,
        component: () => import('./new/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-take.create`,
                PageDescription: "Inventory management: stock take",
            },
        },
    },
    { 
    path: `/${prefix}/stock-take-sheet/print/:storeId`,
    name: `${prefix}.stock-take-list.print`,
     
        component: () => import('./new/prints/stocksheet.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-take.create`,
                PageDescription: "Inventory management: stock take",
            },
            print: true,
        },
    },
    {
        path: `/${prefix}/stock-take-cost-variance`,
        name: `${prefix}.stock-take-cost-variance.index`,
        component: () => import('./new/cost-variance.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-take.create`,
                PageDescription: "Inventory management: stock take",
            },
        },
    }, {
        path: `/${prefix}/stock-take-approval-cost-variance`,
        name: `${prefix}.stock-take-approval-cost-variance.index`,
        component: () => import('./new/approval-cost-variance.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-take.create`,
                PageDescription: "Inventory management: stock take",
            },
        },
    },
];
